import axiosOriginal from 'axios';
import Swal from 'lib/SwalExtension';
import { __ } from 'lib/Utilities';
import { Promise, polyfill as promisePolyfill } from 'es6-promise';
promisePolyfill();
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
axiosOriginal.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */
const token = document.querySelector('meta[name="csrf-token"]');
if (token) {
    axiosOriginal.defaults.headers.common['X-CSRF-TOKEN'] = token.getAttribute("content");
}
else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
axiosOriginal.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if (error.response && error.response.status === 401) {
        Swal.fire({
            title: __('session_expired.title'),
            text: __('session_expired.text'),
            icon: "error",
            confirmButtonText: __('session_expired.confirmButtonText'),
        }).then(() => {
            document.getElementById('logout-form').submit();
        });
    }
    return Promise.reject(error);
});
export const axios = axiosOriginal;
